import $ from 'jquery'
$(function () {
    isElementExist(".review-slider", initReviewSlider);
});

document.addEventListener('DOMContentLoaded', function() {
    const readMoreButtons = document.querySelectorAll('.review-read-more');
    const modal = document.getElementById('reviewModal');
    const modalText = modal.querySelector('#modalText');
    const closeModal = modal.querySelector('.close');

    readMoreButtons.forEach(button => {
        button.addEventListener('click', function() {
            const reviewText = this.getAttribute('data-review');
            modalText.textContent = reviewText;
            modal.style.display = 'block';
        });
    });

    // Close the modal when the user clicks on the (x) button
    closeModal.addEventListener('click', function() {
        modal.style.display = 'none';
    });

    // Close the modal when the user clicks anywhere outside of it
    window.addEventListener('click', function(event) {
        if (event.target === modal) {
            modal.style.display = 'none';
        }
    })
});


// Helper if element exist then call function
function isElementExist(_el, _cb) {
    const elem = document.querySelector(_el);

    if (document.body.contains(elem)) {
        try {
            _cb();
        } catch (e) {
            console.log(e);
        }
    }
}

function initReviewSlider() {
    const reviewSliders = document.querySelectorAll(".review-slider");

    reviewSliders.forEach(function (slider) {
        const buttonNext = slider.parentNode.querySelector(".swiper-button-next");
        const buttonPrev = slider.parentNode.querySelector(".swiper-button-prev");


        const reviewSlider = new Swiper(slider, {
            slidesPerView: 2,
            spaceBetween: 20,
            loop: true,
            watchSlidesProgress: true,

            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                960: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1260: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
            },
        });
    });
}